import { ActivityType, FormCategory } from '.';

export class CustomFormActivityListing
{
    constructor(
        public id:string,
        public templateId:string,
        public category:FormCategory,
        public activityType:ActivityType,
        public activityTitle:string,
        public formId:string,
        public formName:string,
        public formDescription:string,
        public start:Date,
        public end:Date,
        public answerCount:number
    ){}
}
